import {Component, OnInit} from '@angular/core';
import {UPLOAD_SERVICE_TOKEN} from "../../_services/upload.service";
import {ProfilePhotoUploadService} from "../../_services/profile-photo-upload.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../login/services/auth.service";
import {FileStorageService} from "../../_services/filestorage.service";
import {ConfirmedValidator} from "../../_services/confirmed.validator";
import {UserService} from "../dashboard/services/user.service";
import {AlertService} from "../../_shared/alert/alert.service";
import {ProfileMessage} from "../../_services/profile.message";
import {Router} from "@angular/router";

@Component({
  selector: 'profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  providers: [
    { provide: UPLOAD_SERVICE_TOKEN, useClass: ProfilePhotoUploadService },
  ],
})
export class ProfileComponent implements OnInit {
  pwForm: FormGroup = new FormGroup({});
  currentUser: any;
  user: any = {};
  showChangePassword: boolean = true;
  showReferralCode?: boolean;
  roles: any[];
  submitted = false;
  invalid = false;
  imageToShow: any;
  isImageLoading: boolean = true;

  constructor(
    private userService: UserService,
    private alertService: AlertService,
    private authService: AuthService,
    private profileService: ProfileMessage,
    private formBuilder: FormBuilder,
    private fileStorageService: FileStorageService,
    private profileMsg: ProfileMessage,
    private router: Router
  ) {
    this.pwForm = this.formBuilder.group(
      {
        currentPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern('(?=.*d)(?=.*[a-z])(?=.*[A-Z]).{8,}'),
          ],
        ],
        newPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern('(?=.*d)(?=.*[a-z])(?=.*[A-Z]).{8,}'),
          ],
        ],
        confirmPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern('(?=.*d)(?=.*[a-z])(?=.*[A-Z]).{8,}'),
          ],
        ],
      },
      {
        validator: ConfirmedValidator('newPassword', 'confirmPassword'),
      }
    );
  }

  get f() {
    return this.pwForm.controls;
  }

  ngOnInit(): void {
    this.profileMsg.currentMessage.subscribe(r => {
      if(r) {
        this.currentUser = r;
        this.user = r;
        this.roles = this.currentUser?.roles;
        this.showReferralCode = this.roles?.includes('ROLE_BRAND');
      }
    })


    
  }

  //replace with subject behavior
  getUserInfo() {
    this.userService.getUserInfo(this.currentUser.email).then(
      (data: any) => {
        this.user = data;
        this.getProfilePhoto();
      },
      (err: any) => {
        if (err.error) {
          try {
            const res = JSON.parse(err.error);
            this.alertService.error(res.message);
          } catch {
            this.alertService.error(
              `Error with status: ${err.status} - ${err.statusText}`
            );
          }
        } else {
          this.alertService.error(`Error with status: ${err.status}`);
        }

    });
  }

  updateProfile(): void {
    let updatedUser: any = this.user;
    this.userService.updateProfile(updatedUser).then(
      (data: any) => {
        this.alertService.success(data.message, {
          keepAfterRouteChange: true,
        });
      },
       (err: any) => {
        this.alertService.error(err.error.message);

    });
  }

  updateSettings(): void {
    let updatedUser: any = this.user;
    this.userService.updateSettings(updatedUser).then(
      (data: any) => {
        this.alertService.success(data.message, {
          keepAfterRouteChange: true,
        });
      },
      (err: any) => {
        this.alertService.error(err.error.message);

    });
  }

  changePassword(): void {
    this.submitted = true;

    // stop here if form is invalid
    if (this.pwForm.invalid) {
      this.invalid = this.pwForm.invalid;
      return;
    }

    this.authService
      .updatePassword(
        this.pwForm.value['currentPassword'],
        this.pwForm.value['newPassword'],
        this.currentUser.email
      )
      .then(
        (data) => {
          this.alertService.success(data.message, {
            keepAfterRouteChange: true,
          });
        },
        (err) => {
          this.alertService.error(err.error.message);

      });
  }

  getProfilePhoto() {
    this.isImageLoading = true;
    this.fileStorageService.downloadProfilePhoto().then(r => {
        this.createImageFromBlob(r);
        this.isImageLoading = true;
      });
  }

  createImageFromBlob(image: Blob) {
    let reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        this.imageToShow = reader.result;
      },
      false
    );

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  successfulFileUpload($event: boolean) {
    if ($event) {
      this.getUserInfo();
    }
  }
}
